// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientsContent_root__sBjDC","item":"ClientsContent_item__kk3XO","toggleItemsBtn":"ClientsContent_toggleItemsBtn__3lxXk"};